var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h-full rounded",class:`bg-${_vm.color}`,style:({
        width: _vm.width,
        display: _vm.pct > 0 ? 'inline' : 'none',
    })})
}
var staticRenderFns = []

export { render, staticRenderFns }